/* eslint-disable camelcase */
import React from 'react'
import { AutoComplete, Form, Row, Typography } from 'antd'
import PropTypes from 'prop-types'

import { Input, Label } from '~stories'
import { resolveFlagColorFromInput } from '~utils/flagColor'

import { FLAGS_COLOR_CODES } from '../../constants'
import {
  getDefaultConcessionBadge,
  normalizeConcessionBadge
} from '../../utils/concessionGalleryItemDefaults'
import styles from '../FAQPageSections/FAQAdminFields.module.css'
import badgeStyles from './ConcessionBadgeFields.module.css'

const { Item } = Form
const { Text } = Typography

const COLOR_OPTIONS = FLAGS_COLOR_CODES.map(({ name, value }) => ({
  value,
  label: `${name} ${value.replace('#', '')}`
}))

const ConcessionBadgeFields = ({ badge, itemErrors = {}, onChange }) => {
  const normalizedBadge = normalizeConcessionBadge(badge) ?? getDefaultConcessionBadge()
  const {
    title = '',
    color = ''
  } = normalizedBadge
  const previewText = title.trim().toUpperCase()
  const hasPreview = Boolean(previewText || color)

  const updateBadge = patch => {
    onChange({
      ...normalizedBadge,
      ...patch
    })
  }

  const handleColorChange = value => {
    if (!value) {
      updateBadge({ color: '' })
      return
    }

    const resolved = resolveFlagColorFromInput(value)
    updateBadge({ color: resolved?.value || '' })
  }

  return (
    <div className={styles.fieldGroup}>
      <Text className={styles.fieldLabel}>Badge (Flag)</Text>
      <Input
        label="Title"
        onChange={event => updateBadge({ title: event.target.value })}
        value={title}
      />
      <Row style={{ marginTop: 12 }}>
        <Label isInline={false} value="Color" />
      </Row>
      <Row>
        <Item style={{ marginBottom: 0 }}>
          <AutoComplete
            allowClear
            filterOption={(inputValue, option) => {
              const optionValue = (option.value || '').toLowerCase()
              const optionLabel = (option.label || '').toLowerCase()
              const query = (inputValue || '').toLowerCase()
              return optionValue.includes(query) || optionLabel.includes(query)
            }}
            onChange={handleColorChange}
            onClear={() => handleColorChange('')}
            onSelect={handleColorChange}
            options={COLOR_OPTIONS}
            placeholder="Select a color or enter hex"
            style={{ width: 220 }}
            value={color || undefined}
          />
        </Item>
      </Row>
      <Row style={{ marginTop: 12 }}>
        <Label isInline={false} value="Preview" />
      </Row>
      <Row>
        {hasPreview && (
          <div className={badgeStyles.previewBackdrop}>
            <div
              className={badgeStyles.previewBadge}
              style={{ backgroundColor: color || '#d9d9d9' }}
            >
              {previewText && (
                <span className={badgeStyles.previewTitle}>
                  {previewText}
                </span>
              )}
            </div>
          </div>
        )}
      </Row>
      {itemErrors.badge && (
        <Text className={styles.fieldError}>{itemErrors.badge}</Text>
      )}
    </div>
  )
}

ConcessionBadgeFields.propTypes = {
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  itemErrors: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

export default ConcessionBadgeFields
